export default __webpack_public_path__ + "static/media/landing-page-background.8d0577e6.jpeg";